<template>
  <div class="goods">
    <div class="menu-wrap" ref="menu">
      <ul class="menu-list">
        <li class="menu-item border-1px" v-for="(menu,index) in goods" :class="{current:index === currentIndex}"
            @click.stop="selectMenu(index,$event)">
          <span class="text"><span class="icon" :class="classMap[menu.type]" v-show="menu.type > -1"></span><span>{{menu.name}}</span></span>
        </li>
      </ul>
    </div>
    <div class="foods-wrap" ref="foods">
      <ul class="goods-list">
        <li class="goods-item goods-item-hook" v-for="good in goods">
          <h3 class="title">{{good.name}}</h3>
          <ul class="foods-list">
            <li class="food border-1px" v-for="food in good.foods" @click.stop="selectFoodData(food,$event)">
              <img :src="food.icon" alt="图片" class="food-image">
              <div class="food-content">
                <h4 class="food-name">{{food.name}}</h4>
                <span class="desc" v-show="food.description">{{food.description}}</span>
                <div class="count-rating">
                  <span class="count">月售{{food.sellCount}}</span>
                  <span class="rating">好评率{{food.rating}}%</span>
                </div>
                <div class="price-wrap">
                  <span class="price"><i>¥</i>{{food.price}}</span>
                  <span class="old-price" v-show="food.oldPrice"><i>¥</i>{{food.oldPrice}}</span>
                </div>
              </div>
              <div class="control-wrap">
                <control :food="food"></control>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <shopcart :selectFoods="selectFoods"></shopcart>
    <food :food="selectFood" ref="food" @hide="hideFood"></food>
  </div>
</template>

<script type="text/ecmascript-6">
  import {localdata} from 'common/js/data.js';
  import BScroll from 'better-scroll';
  import shopcart from 'components/shopCart/shopCart';
  import control from 'components/cartcontrol/cartcontrol';
  import food from 'components/food/food';
  export default{
    props: {
      seller: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        goods: localdata.goods,
        scrollY: 0,
        listHeight: [],
        selectFood: {}
      };
    },
    created() {
      this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee'];
    },
    mounted() {
      this.$nextTick(() => {
        this._initScroll();
        this._caculateHeight();
      });
    },
    watch: {
      'goods'() {
        this.$nextTick(() => {
          this._initScroll();
          this._caculateHeight();
        });
      }
    },
    methods: {
      _initScroll() {
        if (!this.menuScroll) {
          this.menuScroll = new BScroll(this.$refs['menu'], {
            click: true
          });
        } else {
          this.menuScroll.refresh();
        }
        if (!this.foodScroll) {
          this.foodScroll = new BScroll(this.$refs['foods'], {
            click: true,
            probeType: 3
          });
        } else {
          this.foodScroll.refresh();
        }
        this.foodScroll.on('scroll', (pos) => {
          this.scrollY = Math.abs(Math.round(pos.y));
        });
      },
      _caculateHeight() {
        let foodlist = this.$refs['foods'].getElementsByClassName('goods-item-hook');
        let Height = 0;
        this.listHeight.push(Height);
        for (let i in foodlist) {
          Height += foodlist[i].clientHeight;
          this.listHeight.push(Height);
        }
      },
      selectMenu(index, event) {
        if (!event._constructed) {
          return;
        }
        this.foodScroll.scrollTo(0, -(this.listHeight[index]), 300);
      },
      selectFoodData(data, event) {
        if (!event._constructed) {
          return;
        }
        if (data) {
          this.selectFood = data;
          this.$refs.food.show();
        } else {
          this.selectFood = {};
        }
      },
      hideFood() {
        this.selectFood = {};
      }
    },
    computed: {
      currentIndex() {
        for (let i = 0; i < this.listHeight.length; i++) {
          let height1 = this.listHeight[i];
          let height2 = this.listHeight[i + 1];
          if (this.scrollY >= height1 && this.scrollY < height2 || !height2) {
            return i;
          }
        }
        return 0;
      },
      selectFoods() {
        let foods = [];
        this.goods.forEach((good) => {
          good.foods.forEach((food) => {
            if (food.count && food.count > 0) {
              foods.push(food);
            }
          });
        });
        return foods;
      }
    },
    components: {
      shopcart,
      control,
      food
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../common/stylus/mixin.styl";
  .goods
    display:flex
    flex-direction:row
    position:fixed
    top:174px
    left:0
    right:0
    bottom:48px
    z-index:30
    background-color:#fff
    .menu-wrap
      flex:0 0 80px
      width:80px
      height:100%
      overflow:hidden
      .menu-list
        background-color:#f3f5f7
        .current
          background-color:#fff
        .menu-item
          display:table
          padding:0 12px
          width:100%
          height:54px
          .text
            display:table-cell
            vertical-align:middle
            font-size:12px
            line-height:14px
            border-1px(rgba(7, 17, 27, 0.1))
            .icon
              display:inline-block
              width:12px
              height:12px
              vertical-align:top
            icon-image(3)
    .foods-wrap
      flex:1
      height:100%
      overflow:hidden
      .goods-list
        background-color:#fff
        .goods-item
          .title
            margin:0
            padding-left:10px
            width:100%
            height:26px
            font-size:12px
            line-height:26px
            color:rgb(147, 153, 159)
            border-left:2px solid #d9dde1
            background-color:#f3f5f7
          .foods-list
            padding:0px 18px
            .food
              display:flex
              position:relative
              padding:18px 0
              border-1px(rgba(7, 17, 27, 0.1))
              &:last-child:after
                display:none
              .food-image
                margin-right:10px
                width:57px
                height:57px
                border-radius:2px
              .food-content
                .food-name
                  margin:2px 0px 8px 0px
                  font-size:14px
                  line-height:14px
                  color:rgb(7, 17, 27)
                .desc, .count-rating
                  font-size:10px
                  line-height:10px
                  color:rgb(147, 153, 159)
                .count-rating
                  margin:8px 0
                  .count
                    margin-right:12px
                .price-wrap
                  .price
                    margin-right:8px
                    font-size:14px
                    font-weight:700
                    line-height:24px
                    color:rgb(240, 20, 20)
                    i
                      font-size:10px
                      font-weight:200
                  .old-price
                    font-size:10px
                    font-weight:700
                    line-height:24px
                    color:rgb(147, 153, 159)
                    text-decoration:line-through
                    i
                      font-weight:200
              .control-wrap
                position:absolute
                bottom:10px
                right:0
</style>



// WEBPACK FOOTER //
// goods.vue?0f21fe36